import $ from "jquery";
import "jquery-lazyload";
import Bootstrap from "bootstrap";

// var affixElem = ".site-navigation-main";

// // sticky navigation bar
// $(affixElem).affix({
//   offset: {
//     top: function () {
//       return (this.top = $(affixElem).offset().top);
//     },
//     bottom: function () {
//       return (this.bottom = $(".footer-section").outerHeight(true));
//     },
//   },
// });

var clicked = false;
//the dropdowns on the mobile size
$(".mobile-dd").on("click", function () {
  if (clicked == false) {
    $(this).addClass("open");
    $("ol.breadcrumbs li").not("mobile-dd").show();
    clicked = true;
  } else {
    $(this).removeClass("open");
    $("ol.breadcrumbs li").not(".mobile-dd").hide();
    clicked = false;
  }
});

// fix for modals and catalog issues
$(".hide-with-js").hide();

// Bootstrap Tool Tip Module
$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});

//lazy load svgs in footer as well as any that are provided the .lazy class
$("img.lazysvg, img.lazy").lazyload({
  effect: "fadeIn",
  threshold: 200,
});

$("body").on("click", ".product-box [name=add-on]", function () {
  if (this.checked === false) {
    $("[name='2:name']").remove();
    $("[name='2:price']").remove();
    $("[name='2:code']").remove();
    $("[name='2:image']").remove();
    $("[name='2:quantity']").remove();
  } else {
    $("form[action='https://secure.usnetting.com/cart']").append(
      '<input type="hidden" name="2:name" value="Net Storage Device Add-On" />'
    );
    $("form[action='https://secure.usnetting.com/cart']").append(
      '<input type="hidden" name="2:price" value="196.34" />'
    );
    $("form[action='https://secure.usnetting.com/cart']").append(
      '<input type="hidden" name="2:code" value="OHNSD-PR" />'
    );
    $("form[action='https://secure.usnetting.com/cart']").append(
      '<input type="hidden" name="2:image" value="https://static.usnetting.com/img/ldsn/post/storage-thumb.jpg">'
    );
    $("form[action='https://secure.usnetting.com/cart']").append(
      '<input type="hidden" name="2:quantity" value="' +
        ($("[name=quantity]").val() !== undefined
          ? $("[name=quantity]").val()
          : 1) +
        '" />'
    );
  }
});

$("body").on("change", ".product-box [name=quantity]", function () {
  if ($("[name='2:quantity']").length > 0) {
    $("[name='2:quantity']").val($(this).val());
  }
});

$("body").on(
  "submit",
  "form[action='https://secure.usnetting.com/cart'].accessory-products",
  function () {
    var body = document.querySelector("body");
    body.classList.remove("cart-visible");
    console.log(body.classList);
    setTimeout(function () {
      var form = document.querySelector(
        "form[action='https://secure.usnetting.com/cart'].accessory-products"
      );
      var accessories_page = form.getAttribute("data-accessories-page");
      window.location.href = accessories_page;
    }, 500);
  }
);

// Small Chat was there all the time. I want to control when this shows.
// Also remove it for right now.
// <script src="https://embed.small.chat/T0M09SFLLG5J5B3TCL.js" async></script>



// WEBPACK FOOTER //
// ./pages/main.js